import React from 'react';
import Button from '@material-ui/core/Button';
import ChevronLeftIcon from 'material-ui/svg-icons/navigation/chevron-left';
import './GridOverrideNav.styl';

export const overrideName = 'ResultGridOverride';

export default class GridOverrideNav extends React.Component {
  render() {
    if (!this.props) return;

    const {name, goToChooser, exitScorecard, hasMultipleScorecards} = this.props;

    return (
      <div className="grid-override-header">
        <div className="wrapper">
          {
            <Button
              variant="text"
              className="ev-button"
              onClick={hasMultipleScorecards ? goToChooser : exitScorecard}>
              <ChevronLeftIcon />
              {hasMultipleScorecards ? 'Back To Scorecards' : 'Back'}
            </Button>
          }
          <header>{name}</header>
          <div className="actions">
            {hasMultipleScorecards && (
              <Button variant="outlined" className="ev-button" onClick={goToChooser}>
                Score Another Card
              </Button>
            )}
            <Button
              variant="contained"
              color="primary"
              className="ev-button"
              onClick={exitScorecard}>
              Back To Call
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
